
























import { Component , Vue } from 'vue-property-decorator';
import { MedTransGoConstants } from '../util/constants';
import { ObjectFactory } from '@/config/objectFactory';
import '../assets/css/SessionTimeout.scss';
@Component({})
export default class SessionExpiredModal extends Vue {
    private show = true;

    private logout() {
      ObjectFactory.getCacheService().clearCache();
      ObjectFactory.getCacheService().saveSessionValue(MedTransGoConstants.FIELD_STATE, location.pathname);
      const uncService = ObjectFactory.getUNCService();
      if (uncService.isUNCSubdomain()) {
          location.href = '/';
      } else {
          // Regular login
          const redirectUrl = `${this.$store.state.serverUrl}${MedTransGoConstants.HTTP_URL_LOGIN}?clientId=${this.$store.state.clientId}`;
          location.href = redirectUrl;
      }
    }
}
